import request from '../../../helpers/request';

const deleteCounterpartyAttachment = async (attachmentId, counterparty) => {
  await request.put(
    `/RentPlace/counterparty`,
    {
      ...counterparty,
      attachments: counterparty.attachments?.filter(
        (attachment) => attachment.id !== attachmentId
      ),
    },
    'Произошла ошибка при удалении файла'
  );
};

export default deleteCounterpartyAttachment;
